query GetCaseRecords(
  $page: Int
  $limit: Int
  $filterGroup: CaseRecordFilterGroupInput
  $balanceType: BalanceTypeEnum
  $fundAccountIds: [ID!]
  $sortBy: String
  $includeSageJournalEntries: Boolean
) {
  caseRecords(
    page: $page
    limit: $limit
    filterGroup: $filterGroup
    balanceType: $balanceType
    fundAccountIds: $fundAccountIds
    sortBy: $sortBy
    includeSageJournalEntries: $includeSageJournalEntries
  ) {
    collection {
      id
      description
      caseType {
        id
        name
      }
      salesforceId
      recipientFundAccount {
        id
        currency
        fund {
          id
          name
        }
      }
      senderFundAccount {
        id
        currency
        fund {
          id
          name
        }
      }
      contact {
        id
        name
      }
      senderContact {
        id
        name
      }
      legallyDonatingEntity {
        id
        name
      }
      caseStage {
        id
        name
        includeInBalances
      }
      senderCharity {
        id
        name
      }
      recipientCharity {
        id
        name
      }
      endUserCharity {
        id
        name
      }
      recipientCompany {
        id
        name
      }
      senderCompany {
        id
        name
      }
      submittedBy {
        id
        name
      }
      owner {
        id
        name
      }
      lastModifiedBy {
        id
        name
      }
      createdBy {
        id
        name
      }
      senderAmount {
        minorUnit
        currency
      }
      recipientAmountForRollUps {
        minorUnit
        currency
      }
      fxAtTimeOfTransaction
      transactionDate
      notes
      highImpactAtTimeOfDeployment
      createdAt
      updatedAt
      status
      caseNumber
      displayName
      senderType
      senderName
      recipientType
      recipientName
      hasSyncError
      syncErrorMessage
      sageJournalEntries {
        id
        description
        sageGiftAccount {
          id
          sageId
        }
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
